import { ChangeCell } from "@similarweb/pro-logic-components";

import { changeFilter } from "app/filters/ngFilters";

const formatChange = changeFilter();

interface IPercentageChangeCellProps {
    value?: number;
    /** Optional per-row precision override for the formatted change value. */
    row?: { precision?: number };
}

/** Keeps MoM/period change arrows in sync with the Rank Change column's `ChangeCell` icon. */
export const PercentageChangeCell = ({ value, row }: IPercentageChangeCellProps) => (
    <ChangeCell
        value={value}
        formattedValue={formatChange(Math.abs(value ?? 0), row?.precision)}
        noChangeSign="-"
    />
);

PercentageChangeCell.displayName = "PercentageChangeCell";
